<template>

<v-container>
  <v-layout>
     <v-flex xs12 sm8 offset-sm1>
      <v-card>
          <v-img
            src="/img/rape.jpg"
            aspect-ratio="2.75"
          ></v-img>
              <v-card-title  primary-title>
                <div>
                  <h3 class="headline mb-0">Protección Profesional</h3>
                  <div>
                    <p>Lista de documentos técnicos a ser protegidos por
                    este Colegio de Contadores Públicos del Distrito Capital según la narturaleza comercial del cliente,
                    revisando aspectos de forma y presentación, así como la correcta aplicación de la norma técnica usada.
                    </p>
                  </div>
                </div>
              </v-card-title>

                  <v-treeview
                    :open="open"
                    :items="items"
                    activatable
                    item-key="name"
                    open-on-click
                  >
                   <template slot="label" slot-scope="{ item }">
                      <a v-if="item.document_type_id != null" @click="sendToActuacion(item)">{{ item.name }}</a>
                      <div v-else>{{ item.name }}</div>
                    </template>
                    <template v-slot:prepend="{ item, open }">
                      <v-icon v-if="item.document_type_id == null">
                        {{ open ? 'mdi-folder-open' : 'mdi-folder' }}
                      </v-icon>
                      <v-icon v-else>
                        {{ 'mdi-file' }}
                      </v-icon>
                    </template>
                  </v-treeview>

            <v-card-actions>
                  <v-btn color="primary darken-1"  :to="{ name: 'nueva-actuacion' }">REGISTRAR ACTUACION</v-btn>
            </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>


</template>

<script>
import axios from 'axios'

  export default {
    data () {
    return {
      items: [],
      open: ['public'],

      tree: [],
    }
  },
    mounted() {
    this.getDocumentTypes()
  },
    methods: {

      sendToActuacion(item) {
        this.$router.push({ name: 'nueva-actuacion', params: { item } })
      },

      async getDocumentTypes(){
      await axios.get(`/api/document_types/document-types-mapa`).then(resp => {
        this.items = resp.data.dt
        if(resp.data.dt.length != 0){
          this.recorridoDt(resp.data.dt)
        }
      }).catch(error => {
        console.log(error.response)
      })
    }
    }
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/documentsTypes/documentType.vue